import { render, staticRenderFns } from "./scratchers.vue?vue&type=template&id=30222c8c&scoped=true"
import script from "./scratchers.vue?vue&type=script&lang=js"
export * from "./scratchers.vue?vue&type=script&lang=js"
import style0 from "./scratchers.vue?vue&type=style&index=0&id=30222c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30222c8c",
  null
  
)

export default component.exports